// i18n frontend. Bahasa utama: Bahasa Melayu. Pilihan pengguna disimpan dalam pelayar dan
// dalam profil (apabila log masuk) supaya emel/notifikasi juga dalam bahasa yang sama.
// `t` ialah binding hidup (live binding): modul yang mengimport `t` sentiasa mendapat bahasa semasa.

import { makeT, LOCALES, DEFAULT_LOCALE, normalizeLocale, SUPPORTED_LOCALES } from '../../../shared/i18n/index.js';
import { Raw, raw, esc } from './html.js';

const KEY = 'stayd_locale';

function stored() {
  try { return normalizeLocale(localStorage.getItem(KEY)); } catch { return null; }
}

// Bahasa melalui ?lang= dalam URL (cth. pautan dari halaman SEO) diutamakan sekali sahaja.
function fromUrl() {
  try { return normalizeLocale(new URLSearchParams(location.search).get('lang')); } catch { return null; }
}

let current = fromUrl() || stored() || DEFAULT_LOCALE;
export let t = makeT(current);
export const locales = SUPPORTED_LOCALES.map((code) => ({ code, name: LOCALES[code].name }));

export function getLocale() {
  return current;
}

export function hasExplicitChoice() {
  return !!stored() || !!fromUrl();
}

function apply() {
  document.documentElement.lang = LOCALES[current].htmlLang;
}

export function setLocale(code, { persist = true } = {}) {
  const l = normalizeLocale(code) || DEFAULT_LOCALE;
  if (persist) {
    try { localStorage.setItem(KEY, l); } catch { /* storan disekat — kekal untuk sesi ini */ }
  }
  if (l === current) return false;
  current = l;
  t = makeT(l);
  apply();
  window.dispatchEvent(new CustomEvent('locale-changed', { detail: l }));
  return true;
}

apply();

// Terjemahan yang membenamkan markup (cth. harga tebal) — teks kamus tetap dilarikan,
// hanya parameter Raw dimasukkan sebagai HTML.
export function th(key, params = {}) {
  const marks = {};
  const plain = {};
  for (const [k, v] of Object.entries(params)) {
    if (v instanceof Raw) {
      const tok = `\u0001${k}\u0001`;
      marks[tok] = v.s;
      plain[k] = tok;
    } else plain[k] = v;
  }
  return raw(t(key, plain).split(/(\u0001\w+\u0001)/).map((part) => (part in marks ? marks[part] : esc(part))).join(''));
}
